import moment from 'moment'
// import Vue from 'vue'
import { orderBy } from 'lodash'

export const primaryTextColor = (hex) => {
  const color = (hex || '#1e9d84').trim()
  const r = parseInt(color.slice(1, 3), 16)
  const g = parseInt(color.slice(3, 5), 16)
  const b = parseInt(color.slice(5, 7), 16)
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5 ? '#000000' : '#ffffff'
}

const getTranslation = (key) => {
  try {
    return window.i18n.t(key)
  } catch (e) {
    return key
  }
}

export const getStoreHoursMassaged = (store) => {
    const { orderStoreHours = [] } = store
  
    const dayMap = {
      1: getTranslation('$vuetify.hours.sun'),
      2: getTranslation('$vuetify.hours.mon'),
      3: getTranslation('$vuetify.hours.tues'),
      4: getTranslation('$vuetify.hours.wed'),
      5: getTranslation('$vuetify.hours.thurs'),
      6: getTranslation('$vuetify.hours.fri'),
      7: getTranslation('$vuetify.hours.sat')
    }
  
    const times = []
    for (const dayKey in dayMap) {
      // dayKey is a string, even though its defined as a int in the map.
      const config = orderStoreHours.find(h => h.day === parseInt(dayKey, 10))
  
      const day = dayMap[ dayKey ]
      let open, close
  
      if (config) {
        let openHour, openMinute, closeHour, closeMinute
        if (config.open === 0 && (config.close === 24 || config.close === 0)) {
          open = getTranslation('$vuetify.hours.twentyFourHours')
        } else if (config.open !== 0 && (config.close === 24 || config.close === 0)) {
          openHour = moment.duration(config.open, 'hours').get('hours')
          openMinute = moment.duration(config.open, 'hours').get('minutes')
          open = moment({ hour: openHour, minute: openMinute }).format('hh:mm A')
          close = getTranslation('$vuetify.hours.midNight')
        } else {
          openHour = moment.duration(config.open, 'hours').get('hours')
          openMinute = moment.duration(config.open, 'hours').get('minutes')
          open = moment({ hour: openHour, minute: openMinute }).format('hh:mm A')
  
          closeHour = moment.duration(config.close, 'hours').get('hours')
          closeMinute = moment.duration(config.close, 'hours').get('minutes')
          close = moment({ hour: closeHour, minute: closeMinute }).format('hh:mm A')
        }
  
        const dayInt = config.day
  
        times.push({ day, open, close, dayInt })
      } else {
        open = getTranslation('$vuetify.common.closed')
        times.push({ day, open, close, dayInt: dayKey })
      }
    }
  
    return orderBy(times, 'dayInt')
  }